import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { LOCATIONS } from "@/data/locations";

const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7"];

export const Locations = () => (
  <section id="locations" data-testid="locations-section" className="bg-[#F9F8F4] py-16 md:py-36">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <div data-testid="locations-divider" aria-hidden="true" className="flex items-center justify-center gap-6 mb-14 md:mb-20">
        <span className="h-px w-16 md:w-28 bg-[#0A2333]/15" />
        <img src="/assets/nua-mark-transparent.png" alt="" className="h-9 w-auto opacity-90" />
        <span className="h-px w-16 md:w-28 bg-[#0A2333]/15" />
      </div>
      <Reveal>
        <h2 data-testid="locations-heading" className="font-serif text-3xl md:text-4xl tracking-tight text-[#111413]">
          Financial advice. Wherever you are.
        </h2>
        <p className="mt-6 text-base leading-relaxed text-[#4A524D] max-w-xl">
          Based in Canberra, we work with clients across the ACT, NSW and throughout Australia.
          Whether you prefer to meet in person or connect securely online, you'll receive the
          same independent, personalised advice, wherever life takes you.
        </p>
      </Reveal>

      <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
        {LOCATIONS.map((l, i) => (
          <Reveal key={l.slug} delay={i * 0.06} className={SPANS[i]}>
            <Link
              to={`/locations/${l.slug}`}
              data-testid={`location-card-${l.slug}`}
              className="group block border border-black/10 bg-white h-full"
            >
              <div className="overflow-hidden h-56 md:h-64">
                <img
                  src={l.image}
                  alt={l.imageAlt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-6 md:p-8 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl tracking-tight text-[#111413]">{l.name}</h3>
                  <p className="mt-1 text-[10px] uppercase tracking-[0.25em] text-[#A78558]">{l.region}</p>
                  <p className="mt-4 text-sm leading-relaxed text-[#4A524D]">{l.card}</p>
                </div>
                <ArrowUpRight
                  aria-hidden="true"
                  size={22}
                  className="mt-1 shrink-0 text-[#0A2333] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
            </Link>
          </Reveal>
        ))}
      </div>

      <Reveal>
        <Link
          to="/online-advice"
          data-testid="locations-online-advice-link"
          className="group mt-10 md:mt-12 flex flex-col md:flex-row md:items-center justify-between gap-4 bg-[#0A2333] px-6 py-7 md:px-10 md:py-8 transition-[background-color] duration-300 hover:bg-[#071824]"
        >
          <div>
            <p className="font-serif text-2xl md:text-3xl tracking-tight text-[#F9F8F4]">Can't meet face to face? Meet online.</p>
            <p className="mt-2 text-sm leading-relaxed text-white">
              Work with Kevin online via video call from anywhere in Australia.
            </p>
          </div>
          <span className="inline-flex shrink-0 items-center gap-2 text-xs uppercase tracking-[0.15em] text-[#F9F8F4]">
            How online advice works
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </span>
        </Link>
      </Reveal>
    </div>
  </section>
);
